/* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { akEditorSmallZIndex, relativeFontSizeToBase16 } from '@atlaskit/editor-shared-styles';
import { N20 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var inviteTeamWrapperStyles = css({
  background: "var(--ds-background-neutral, ".concat(N20, ")"),
  borderRadius: '50%',
  minWidth: "var(--ds-space-400, 32px)",
  marginLeft: "var(--ds-space-negative-050, -4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var avatarContainerStyles = css({
  marginRight: "var(--ds-space-100, 8px)",
  display: 'flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&& > ul': {
    listStyleType: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  'div:last-child button.invite-to-edit': {
    borderRadius: '50%',
    height: '32px',
    width: '32px',
    padding: "var(--ds-space-025, 2px)"
  }
});
export var badge = function badge(backgroundColor, textColor) {
  return css({
    display: 'block',
    position: 'absolute',
    right: "var(--ds-space-025, 2px)",
    bottom: "var(--ds-space-025, 2px)",
    width: "var(--ds-space-150, 12px)",
    height: "var(--ds-space-150, 12px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: akEditorSmallZIndex,
    borderRadius: '3px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: backgroundColor,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: textColor,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: relativeFontSizeToBase16(9),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    paddingTop: "var(--ds-space-075, 6px)",
    textAlign: 'center',
    boxShadow: "0 0 1px ".concat("var(--ds-border-inverse, #fff)"),
    boxSizing: 'border-box'
  });
};